<template>
	<div
		class="card-product-big"
		v-loading="isLoading"
		ref="cardProduct"
		@mouseover="changeStyle('border')"
		@mouseleave="changeStyle()"
	>
		<div 
			class="products-wrapper relative"
			:class="{'margin-auto':isPossiblyLike, 'wrapper-like': isPossiblyLike}"
			@click="goToProduct(product)">
			<div
				:class="[
					'wrapper-discount', 'd-flex',
					hideHeart ? 'justify-end' : 'space-between',
				]">
				<heart-svg :active="Number(product.flagFavorite)" @click="addToFavorites" v-if="!hideHeart"/>
				<div
					class="number-discount"
					:style="`background-color:${globalColors.titulo}`"
					ref="discount"
				>
					<p class="number">{{discountPercentage}}%</p>
				</div>	
			</div>
			<div class="wrapper-image-product d-flex align-center justify-center">
				<div
					class="number-discount-mobile"
					:style="`background-color:${globalColors.titulo}`"
				>
					<p class="number">{{discountPercentage}}%</p>
				</div>
				<img
					:src="product.urlImage" 
					:alt="product.name"
					class="products-image"
					:class="{'image-like': isPossiblyLike}"
					>
			</div>
			<div class="mobil-container">
				<div class="wrapper-description">
					<div class="like-mobile">
						<heart-svg :active="product.flagFavorite" @click="addToFavorites"/>
					</div>
					<p class="text-product-name">{{getProductName}}</p>
					<p class="text-description">{{capitalizeDescription}}</p>
					<p class="text-price-now" v-if="product.price"><del>{{getCurrencySymbol}} {{product.price | priceFormat }}</del></p>
					<p
						class="text-price-before"
						:style="`color:${globalColors.primary}`"
					>{{getCurrencySymbol}} {{product.priceDiscount | priceFormat}}</p>
				</div>
				<p class="txt-center text-grey">{{text}}</p>
			</div>
			<div class="wraper-is-not-stock" v-if="noStock">
				<span class="text-is-not">AGOTADO</span>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import heartSvg from '@/components/svg-components/heartSvg';

function discountPercentage() {
	const { price, priceDiscount } = this.product;
	if (price && priceDiscount) {
		return Number((((price - priceDiscount) / price) * 100).toFixed(2)) || 0;
	}
	return 0;
}

function isPossiblyLike() {
	return this.$route.name === 'products';
}

function capitalizeDescription() {
	const [first, ...rest] = this.product.description;
	return `${first && first.toUpperCase()}${rest.join('').toLowerCase()}`;
}
async function addToFavorites() {
	const { token } = this.$store.state;
	if (token) {
		this.isLoading = true;
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		const url = `products/favorite/${this.product.id}`;
		const body = {
			isFavorite: !this.product.flagFavorite,
		};
		await this.$httpQtc.post(url, body, { headers });
		this.$set(this.product, 'flagFavorite', Number(!this.product.flagFavorite));
		this.isLoading = false;
	} else {
		this.$message({
			message: 'Debe iniciar sesión para agregar a favoritos',
			showClose: true,
			type: 'error',
		});
	}
}

function noStock() {
	const stock = !!this.product.stockWarehouse;
	const positiveStock = this.product.stockWarehouse > 0;
	return !(stock && positiveStock);
}

function data() {
	return {
		colors: [],
		isLoading: false,
		text: '',
	};
}

function created() {
	this.colors = process.env.COLORS;
}

function goToProduct({ slug, id }) {
	this.$router.push({ name: 'products', params: { id: slug || id } });
}

function getProductName() {
	const { name } = this.product;
	if (name.length > 38) {
		const txt = name.substring(0, 38);
		return `${txt}...`;
	}
	return name;
}

function changeStyle(color) {
	const borderStyle = color ? 'solid' : null;
	const borderWidth = color ? '0.2rem' : null;
	const borderColor = color ? this.globalColors[color] : null;
	const bgDicount = color ? this.globalColors.primary : this.globalColors.titulo;
	this.$refs.cardProduct.style.borderStyle = borderStyle;
	this.$refs.cardProduct.style.borderWidth = borderWidth;
	this.$refs.cardProduct.style.borderColor = borderColor;
	this.$refs.discount.style.backgroundColor = bgDicount;
}

export default {
	name: 'card-product-big',
	data,
	components: {
		heartSvg,
	},
	computed: {
		...mapGetters([
			'getCurrencySymbol',
		]),
		capitalizeDescription,
		discountPercentage,
		getProductName,
		isPossiblyLike,
		noStock,
	},
	methods: {
		addToFavorites,
		changeStyle,
		goToProduct,
	},
	created,
	props: {
		category: {
			default: true,
			type: Boolean,
		},
		hideHeart: {
			default: false,
			type: Boolean,
		},
		product: {
			default: () => {},
			type: Object,
		},
	},
};
</script>
<style lang="scss" scoped>
	.card-product-big {
		height: 30.5rem;
		
		&:hover {
			box-shadow: 0 0.2rem 0.2rem 0 rgba(31, 26, 26, 0.07);

			.number-discount {
				background: color(defaultOrange);
			}
		}
		
		&:hover .no-stock-container {
			background-color: color(defaultBlack);
			filter: opacity(0.5);
		}

		&:hover .no-stock {
			display: block;
		}
	}

	.wrapper-image-product {
		height: 12.5rem;
		position: relative;
		margin-bottom: 1rem;
		min-width: 17rem;
	}

	.like-mobile {
		display: none;
	}

	.star-none {
		display: none;
	}

	.products-image {
		height: 100%;
		object-fit: contain;
		width: 100%;
	}

	.products-wrapper {
		border: solid 0.2rem transparent;
		box-shadow: 0 0.2rem 0.2rem 0 rgba(0, 0, 0, 0.07);
		cursor: pointer;
		height: 100%;
		padding: 0.4rem 0 0.4rem 0;
		transition: all .4s ease-in-out 0s;
		width: 100%;

		&.margin-auto {
			margin: 0 auto 2rem !important;
		}

	.products-category {
		border: solid 0.2rem transparent;
		box-shadow: 0 0.2rem 0.2rem 0 rgba(0, 0, 0, 0.07);
		height: 12rem;
		padding: 1rem;
		width: 25.5rem;
	}	

		.number-discount {
			color: white;
			font-size: size(normal);
			padding: 0.3rem 0.9rem;
			transition: all .4s ease-in-out 0s;
		}
		
		.number {
			margin: 0;
		}

		.wrapper-description {
			font-size: size(medium);
			text-align: center;

			p {
				margin: 0 auto;
				width: 90%
			}

			.text-product-name {
				height: 3.3rem;
				margin: 0 auto 0.4rem;
				width: 100%;

				@media (max-width: 645px) {
					max-height: 4.5rem;
				}
			}

			.text-description {
				font-size: size(small);
				margin: 0 auto 0.4rem;
				height: 3rem;
				overflow: auto;
			}

			.text-price-now {
				color: color(text-grey);
				font-size: size(msmall);
			}

			.text-price-before {
				font-family: font(open-bold);
				font-size: size(maxsmall);
				margin-bottom: 0.6rem;
			}
		}

		.star-like {
			margin-right: 0.8rem;
		}

		.text-grey {
			color: color(text-grey-max);
			margin: 0;
		}

		.like-mobile {
			display: none;
		}

		.number-discount-mobile {
			display: none;
		}
	}

	.wrapper-rating {
		display: block;
		margin-bottom: 0.5rem;
	}

	.wrapper-discount {
		margin-bottom: 1rem;
	}

	@media (max-width: 645px) {
		.card-product-big {
			border-top: 0.1rem solid color(borderGreyMax);
			flex: 1 1 100%;
			height: 19rem;
			padding: 0.5rem 1rem 0.4rem;
		}

		.products-image {

			&.image-like {
				max-height: 8.6rem;
    			max-width: 8rem;
			}
		}

		.mobil-container {
			flex: 1 1 60%;
			padding: 0 0.5rem;
		}

		.products-wrapper {
			border-bottom: none;
			box-shadow: none;
			box-sizing: border-box;
			display: flex;
			height: 100%;
			margin-bottom: 0;
			justify-content: space-between;
			padding: 0 1rem;
			flex: 1 1 auto;
			width: auto;

			&.wrapper-like {
				border: none !important;
				width: auto;
			}

			.wrapper-discount {
				display: none;
			}

			.wrapper-image-product {
				height: 100%;
				flex: 1 1 40%;
				max-width: 13rem;
				min-width: 0;
			}

			.like-mobile {
				display: flex;
				justify-content: flex-end;
				margin-bottom: 2.6rem;

				img {
					height: 2.5rem;
					width: 2rem;
				}
			}

			.number-discount-mobile {
				align-items: center;
				color: white;
				display: flex;
				height: 2.5rem;
				font-size: size(maxsmall);
				justify-content: center;
				position: absolute;
				right: -1rem;
				text-align: center;
				top: 0;
				width: 9rem;
			}

			.text-description {
				margin-bottom: 0.3rem !important;
			}

			.text-price-before {
				height: 100%;
			}

			.text-price-now {
				width: 100%;
			}

			.star-like {
				height: 0.8rem;
			}

			.text-grey  {
				font-size: size(minsmall);
			}

			.wrapper-rating {
				margin-bottom: 0;
			}
		}
	}

	.no-stock-container {
		background-color: transparent;
		height: 100%;
		left: 0;
		top: 0;
		width: 100%;
		z-index: 9;
	}

	.no-stock {
		background-color: color(defaultBlack);
		color: color(veryLightGrey);
		display: none;
		height: 4rem;
	}

	.wraper-is-not-stock {
		align-items: center;
		background-color: rgba(0, 0, 0, 0.62);
		color: color(white);
		display: flex;
		height: 4.3rem;
		justify-content: center;
		position: absolute;
		top: 31%;
		transform: translateY(-50%);
		width: 100%;

		.text-is-not {
			font-family: font(avenirBold);
			font-size: size(maxsmall);
		}

		@media (max-width: 768px) {
			top: 50%;
		}
	}

</style>




// WEBPACK FOOTER //
// cardProductBig.vue?839cd976